import React from 'react';
import { RouteObject } from 'react-router-dom';
import { societesBasePath, listeSocietesPath } from './constants';
import { SocietesRoot } from './societesRoot';
import ListeSousClient from './page/liste/ListeSousClient';
import ListeSousClientPrescripteurWrapper from './page/liste/ListeSousClientPrescripteurWrapper';

export const SocietesRouter: RouteObject = {
    path: societesBasePath,
    element: <SocietesRoot />,
    handle: { title: 'Sociétés' },
    children: [
        {
            path: listeSocietesPath,
            element: <ListeSousClientPrescripteurWrapper showPrescripteur={false} />,
            handle: { title: 'Sociétés - Liste' },
        },
    ],
};

export const SocietesRouterBack: RouteObject = {
    path: societesBasePath,
    element: <SocietesRoot />,
    handle: { title: 'Sociétés' },
    children: [
        {
            path: listeSocietesPath,
            element: <ListeSousClient showPrescripteur />,
            handle: { title: 'Sociétés - Liste' },
        },
    ],
};
